<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" >
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input disabled v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input disabled v-model="selectedProject"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input disabled v-model="selectedSellContract"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="授信银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="bankFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'issuing_bank_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入银行名称"
                :default-active-first-option="false"
                @search="this.bankSearch"
              >
                <a-spin v-if="bankFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in bankList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行业务品种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'bank_services_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in bankServicesTypeList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="业务金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['business_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'business_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="拟占用敞口金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" v-decorator="['planned_exposure_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'planned_exposure_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金额溢装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['business_amount_more_clause', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="溢装"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金额短装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['business_amount_less_clause', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="短装"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="重量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" allow-clear :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" v-decorator="['weight', { initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
              <a-select
                style="width: 50%"
                placeholder="选择重量单位"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :not-found-content="null"
                :default-active-first-option="false"
                v-decorator="['weight_unit', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit" :label="val">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="重量溢短装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['weight_more_less_clause', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="承兑金额"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金比例" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" v-decorator="['margin_ratio', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" /> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保证金来源" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'margin_source',
                  {
                    rules: [
                      { required: false, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in marginSourceList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedSellContract">
            <a-form-item label="开证时间" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['lc_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开证时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              信用证一般信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="通知行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="advisingBankFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'advising_bank_id',
                  {
                    rules: [
                      { required: false, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入银行名称"
                :default-active-first-option="false"
                @search="this.advisingBankSearch"
              >
                <a-spin v-if="advisingBankFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in advisingBankList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="最晚装货期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['latest_shipment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="装货期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="装港" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['loading_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="卸港" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['discharge_port', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="分批装运" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_partial_shipment', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="转运" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_transfer_shipment', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="交单期" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['presentation_period', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              45A
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="45A货描" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['goods_services_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              46A单据
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="按照合同填写" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_according_contract', { initialValue: true, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否" @change="handleAccordingContractChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="!accordingContract">
            <a-form-item label="46A单据要求" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['documents_required', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              47A其他单据
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="单据要求" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['additional_conditions', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6" :offset="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit" :loading="submitting">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import moment from 'moment'
import { lc_application_list, lc_application_update } from '@/api/trade_credit_letter'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
const fields = ['business_no', 'issuing_bank_id', 'bank_services_type', 'business_amount', 'business_currency', 'business_amount_more_clause', 'business_amount_less_clause',
  'planned_exposure_amount', 'planned_exposure_currency', 'margin_ratio', 'margin_source', 'lc_date', 'advising_bank_id',
'latest_shipment_date', 'loading_port', 'discharge_port', 'is_partial_shipment', 'is_transfer_shipment', 'presentation_period', 'goods_services_desc', 'is_according_contract',
'documents_required', 'additional_conditions', 'is_approval_needed']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.bankSearch = debounce(this.handleBankSearch, 800)
    this.advisingBankSearch = debounce(this.handleAdvisingBankSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      bankServicesTypeList: this.$Dictionaries.bank_services_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      data: undefined,
      loading: false,
      submitting: false,
      bankFetching: false,
      advisingBankFetching: false,
      bankList: [],
      advisingBankList: [],
      issuingBankId: undefined,
      accordingContract: true,
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      }
    }
  },
  mounted () {
    this.loading = true
    lc_application_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.accordingContract = this.data.is_according_contract
          this.loadEditInfo(this.data)
        }
      }).finally(() => {
        this.loading = false
    })
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    selectedSellContract () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.sell_contract.name + '[' + this.data.sell_contract.number + ']'
    },
    selectedProject () {
      if (this.data === undefined) {
        return ''
      }
      return this.data.project
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          this.loading = true
          this.submitting = true
          lc_application_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            }).finally(() => {
              this.loading = false
              this.submitting = false
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    generateFormData (data) {
      const formData = pick(data, fields)
      formData.bank_services_type = '' + formData.bank_services_type
      formData.margin_source = '' + formData.margin_source
      if (formData.issuing_bank_id === -1) {
        formData.issuing_bank_id = undefined
      }
      if (formData.advising_bank_id === -1) {
        formData.advising_bank_id = undefined
      }
      if (formData.lc_date === '1970-01-01') {
        formData.lc_date = undefined
      }
      if (formData.latest_shipment_date === '1970-01-01') {
        formData.latest_shipment_date = undefined
      }
      formData.type = String(formData.type)
      return formData
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = this.generateFormData(data)
        form.setFieldsValue(formData)
      }).finally(() => {
        if (data.issuing_bank_id && data.issuing_bank_id > 0) {
          this.backLoadList({ id: data.issuing_bank_id }, 1)
        }
        if (data.advising_bank_id && data.advising_bank_id > 0) {
          this.backLoadList({ id: data.advising_bank_id }, 2)
        }
      })
    },
    handleBankSearch (value) {
      this.backLoadList({ name: value }, 1)
    },
    handleAdvisingBankSearch (value) {
      this.backLoadList({ name: value }, 2)
    },
    backLoadList (parameter, index) {
      if (index === 1) {
        this.bankFetching = true
      } else {
        this.advisingBankFetching = true
      }
      bank_list(parameter).then((res) => {
        if (index === 1) {
          this.bankList = res.data.entries || []
        } else {
          this.advisingBankList = res.data.entries || []
        }
      }).finally(() => {
        if (index === 1) {
          this.bankFetching = false
        } else {
          this.advisingBankFetching = false
        }
      })
    },
    handleAccordingContractChange (value) {
      this.accordingContract = value
    }
  }
}
</script>
